import IpcRouter from '@shared/ipc/IpcRouter.ts'

export interface FlagsIpcRouterType {
  /**
   * Re-evaluate LaunchDarkly flags for the signed-in user and write the result
   * to the `flags` store. Lets the renderer pull a value granted mid-session
   * (e.g. trusted-tester access) instead of waiting on a relaunch.
   */
  refresh: () => Promise<void>
}

class FlagsIpcRouter extends IpcRouter<FlagsIpcRouterType> {
  constructor() {
    super('flags', {
      refresh: true,
    })
  }
}

export default FlagsIpcRouter
